import {IRouteProps} from "../../../../ts/manager/view/ViewInterface";
import {PostDataChoice} from "../../../../ts/data/subject/PostDataFactory";
import React, {DetailedHTMLProps, HTMLAttributes, useState} from "react";
import {formatPhoneNumber} from "../../../../ts/common/SiteHelper";
import MapLibreMap from "../../../../module/osm/MapLibreMap";
import {IMarkerProps} from "../../../../module/osm/element/MapMarker";
import OsmLocationMapView from "../../../partial/snippet/OsmLocationMapView";
import {MapProps} from "react-map-gl/maplibre";
import AppButton from "../../../element/button/AppButton";

interface IProps
{
    routeProps:IRouteProps;
    postChoice:PostDataChoice;
    blockTitle?:string;
}

const LocationAndMapView = (props:IProps) =>
{
    let [primaryMarkerProps, setPrimaryMarkerProps] = useState<IMarkerProps|null >(null);
    const [mapProps, _] = useState<MapProps>({
        initialViewState:{
            zoom: 12
        }
    });
    const [outerContainerProps, __] = useState<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>>({
        style: {
            height: "100%",
        }
    });
    const postChoice = props.postChoice;

    const requirePrimaryMarkerProps = () => {
        const fromProps = postChoice.location?.getMarkerProps() ?? null;
        if(primaryMarkerProps){
            return;
        }
        if(!fromProps){
            if(primaryMarkerProps){
                primaryMarkerProps = null;
                setPrimaryMarkerProps(null);
            }
            return;
        }

        primaryMarkerProps = {
            ...fromProps,
            popupContent: <OsmLocationMapView
                name={postChoice.name}
                address={[
                    {
                        value: postChoice.addressVO.address,
                        className: "street",
                    },
                    {
                        value: postChoice.addressVO.town,
                        className: "town",
                    },
                    {
                        value: postChoice.addressVO.county,
                        className: "county",
                    },
                    {
                        value: postChoice.addressVO.postcode,
                        className: "postcode",
                    }
                ]}
                telephoneNumber={postChoice.telephoneNumber}
                emailAddress={postChoice.emailAddress}
            />
        }
        setPrimaryMarkerProps(primaryMarkerProps);

    }

    requirePrimaryMarkerProps();

    return <>


        <div className="bg-map-content">

            {primaryMarkerProps && <>
                <MapLibreMap
                    routeProps={props.routeProps}
                    preferredMapFocus={"primary_marker"}
                    primaryMarker={primaryMarkerProps}
                    map={mapProps}
                    outerContainer={outerContainerProps}
                />
            </>}
        </div>
        <div className="container">
            <div className="row">
                <div className="col-12 col-lg-4">

                    <div className="atop-map">
                        {!!props.blockTitle && <>
                            <h2 className="block-title">{props.blockTitle}</h2>
                        </>}
                        <ul className="vertical-icons no-icon">

                            {postChoice.addressVO.getAddressDetails().map((detail, index) =>

                                <li
                                    key={index}
                                >
                                    {detail.name}
                                </li>
                            )}
                            {!!postChoice.lngLat && <li>{postChoice.lngLat.lat + " " + postChoice.lngLat.lng}</li>}
                        </ul>
                        <ul className="vertical-list">
                            {!!postChoice.websiteAddress && <li>

                                <span className="is-fa fa-solid fa-link" aria-hidden="true"></span>
                                <AppButton href={postChoice.websiteAddress} target="_blank" rel="noopener">Visit
                                    Website</AppButton>
                            </li>}
                            {!!postChoice.emailAddress && <li>

                                <span className="is-fa fa-solid fa-envelope" aria-hidden="true"></span>
                                <AppButton href={"mailto:" + postChoice.emailAddress}
                                           title={"Send email to " + postChoice.emailAddress}>Send Email</AppButton>
                            </li>}
                            {!!postChoice.telephoneNumber && <li>

                                <span className="is-fa fa-solid fa-phone" aria-hidden="true"></span>
                                <AppButton href={"tel:" + formatPhoneNumber(postChoice.telephoneNumber)}
                                           title={"Call " + postChoice.telephoneNumber}>{postChoice.telephoneNumber}</AppButton>
                            </li>}
                            {!!postChoice.mobileNumber && <li>

                                <span className="is-fa fa-solid fa-mobile" aria-hidden="true"></span>
                                <AppButton href={"tel:" + formatPhoneNumber(postChoice.mobileNumber)}
                                           title={"Call " + postChoice.mobileNumber}>{postChoice.mobileNumber}</AppButton>
                            </li>}
                            {!!postChoice.faxNumber && <li>

                                <span className="is-fa fa-solid fa-fax" aria-hidden="true"></span>
                                <AppButton href={"tel:" + formatPhoneNumber(postChoice.faxNumber)}
                                           title={"Call " + postChoice.faxNumber}>{postChoice.faxNumber}</AppButton>
                            </li>}
                            {!!postChoice.addressVO.getAddressDetailsGMap() && <li>

                                <span className="is-fa fa-solid fa-map" aria-hidden="true"></span>
                                <AppButton
                                    href={"https://www.google.com/maps/search/?api=1&query=" + postChoice.addressVO.getAddressDetailsGMap() + "&zoom=14&basemap=roadmap"}
                                    target="_blank" rel="noopener">
                                    Open in Google Maps
                                </AppButton>
                            </li>}
                        </ul>
                        {!!postChoice.socialChannelsVOs.length && <>
                            <ul className="horizontal-icons white mt-5">

                                {postChoice.socialChannelsVOs.map((socialChannelsVO, index) =>

                                    <li key={index} className={"sc " + socialChannelsVO.id}>
                                        <AppButton href={socialChannelsVO.url} target="_blank" rel="noopener"
                                                   title={socialChannelsVO.title + " on " + socialChannelsVO.title}>
                                            <span className="visually-hidden">{socialChannelsVO.title}</span>
                                        </AppButton>
                                    </li>
                                )}
                            </ul>
                        </>}
                    </div>

                </div>
            </div>
        </div>
    </>
}
export default LocationAndMapView;